'use strict';

module.exports = {
  contentful: {
    // AccessToken are fetched through auth0 login
    // accessToken: 'b3dc10693eed23f7a3051c327fac87d81e023f2ee1c6abb535ce56164031032c',
    spaceId: 'mt8w0y3iajsh',
    environment: 'staging'
  },
  services: {
    MG_PROTOCOL: 'http',
    MG_DOMAIN: 'localhost',
    MG_PORT: '3000', // 3000 is the port motorgruppen-dealer-services is set up with in the repo. To override this port, use MG_PORT env variable
    MG_SERVICES_BASE: '/services/'
  },
  taskQueue: {
    protocol: 'http',
    hostname: 'localhost',
    port: 3002,
    pathname: '/task-queue/'
  }
};
